import { toBusinessDate } from "@/lib/utils/attendance-date";

/** Real period-over-period trend for any two comparable counts. Returns
 * undefined (no trend pill rendered) when there's no previous-period figure
 * to compare against, rather than fabricating a percentage. */
export function computeTrend(currentValue: number, previousValue: number | undefined): { value: string; positive: boolean } | undefined {
  if (!previousValue) return undefined;
  return {
    value: `${Math.abs(Math.round(((currentValue - previousValue) / previousValue) * 100))}%`,
    positive: currentValue >= previousValue,
  };
}

/** Start of the current calendar month, "YYYY-MM-DD" - used to count real
 * new joiners this month from an already-fetched roster page rather than a
 * fabricated figure. */
export function startOfMonthISO(): string {
  const now = new Date();
  // Formatted from the LOCAL month, never via toISOString(): converting a
  // local midnight to UTC hands back the last day of the PREVIOUS month for
  // anyone east of Greenwich, so "this month's joiners" silently started a
  // day early.
  return toBusinessDate(new Date(now.getFullYear(), now.getMonth(), 1));
}

export function greeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export const KPI_TONE_CLASSES: Record<string, string> = {
  primary: "bg-primary-50 text-primary-700",
  accent: "bg-accent-50 text-accent-700",
  emerald: "bg-emerald-50 text-emerald-600",
  indigo: "bg-indigo-50 text-indigo-600",
  amber: "bg-amber-50 text-amber-600",
};

